const PlusIcon = () => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
   </svg>
)

function AddButton({ onClick }) {
   return (
      <button className="btn-add" onClick={onClick} title="Add item">
         <PlusIcon />
         <span>Add</span>
      </button>
   )
}

export default AddButton
